<h2 mat-dialog-title>Удалить прокат?</h2>
<mat-dialog-content>
  <div class="warn-icon-wrap">
    <mat-icon color="warn" class="warn-icon">warning</mat-icon>
  </div>
  <p class="warn-text">Это действие нельзя отменить.</p>
  <div class="rental-meta">
    <div class="rental-meta-row">
      <span>Автомобиль:</span>
      <strong>{{ data.rental.car_title }}</strong>
    </div>
    <div class="rental-meta-row" *ngIf="data.rental.license_plate">
      <span>Госномер:</span>
      <strong>{{ data.rental.license_plate }}</strong>
    </div>
    <div class="rental-meta-row">
      <span>Клиент:</span>
      <strong>{{ data.rental.client_name }}</strong>
    </div>
    <div class="rental-meta-row">
      <span>Статус:</span>
      <strong>{{ data.rental.status_display }}</strong>
    </div>
    <div class="rental-meta-row">
      <span>Период:</span>
      <strong>{{ data.rental.handover_datetime | date:'medium' }} — {{ (data.rental.return_datetime || data.rental.expected_return_datetime) | date:'medium' }}</strong>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Отмена</button>
  <button mat-raised-button color="warn" (click)="dialogRef.close(true)">Удалить</button>
</mat-dialog-actions>
